import { Tooltip } from '@scaleaq/scaleui';

import { Z_INDEX } from '@/constants';

import { radialPadTooltip } from '../radialControlPad.constants.ts';
import { RadialTooltipAnchor } from '../radialControlPad.style.ts';

type RadialSectorTooltipProps = {
  label: string;
  left: number;
  top: number;
  open: boolean;
};

/**
 * HTML-layer tooltip for a sector (paired with {@link RadialSectorButton}).
 * Rendered in {@link RadialTooltipLayer}, not inside the SVG tree.
 */
export const RadialSectorTooltip = ({ label, left, top, open }: RadialSectorTooltipProps) => (
  <Tooltip
    tooltip={label}
    open={open}
    placement='top'
    offset={{ mainAxis: radialPadTooltip.bubbleGap }}
    strategy='fixed'
    usePortal
    zIndex={Z_INDEX.overlay.panel + 1}
  >
    <RadialTooltipAnchor $left={left} $top={top} />
  </Tooltip>
);
